// src/theme.js
import { createTheme } from '@mui/material/styles';
import palette from './palette';

const theme = createTheme({
  palette: palette,
  typography: {
    fontFamily: '"Manrope", "Arial", sans-serif', // A neutral sans-serif font for better readability.
    h1: {
      fontSize: '2.5rem',
      fontWeight: 700,
      textOverflow: "ellipsis",
      "@media (max-width: 600px)": {
        fontSize: '1.5rem',
      },
      "@media (max-width: 900px)": {
        fontSize: '2rem',
      },


    },
    h2: {
      fontSize: '2rem',
      fontWeight: 600,
      color: '#002855', // Also in blue for headers.
      textOverflow: "ellipsis",
      "@media (max-width: 600px)": {
        fontSize: '1rem',
      },
      "@media (max-width: 900px)": {
        fontSize: '1.5rem',
      },

    },
    h3: {
      fontSize: '1.5rem',
      fontWeight: 600,
      textOverflow: "ellipsis",
      "@media (max-width: 600px)": {
        fontSize: '1rem',
      },
      "@media (max-width: 900px)": {
        fontSize: '1.2rem',
      },

    },
    h4: {
      fontSize: '1.2rem',
      fontWeight: 600,
      textOverflow: "ellipsis",
      "@media (max-width: 600px)": {
        fontSize: '0.8rem',
      },
      "@media (max-width: 900px)": {
        fontSize: '1rem',
      },

    },
    h5: {
      fontSize: '1rem',
      fontWeight: 600,
      textOverflow: "ellipsis",
      "@media (max-width: 600px)": {
        fontSize: '0.8rem',
      },
      "@media (max-width: 900px)": {
        fontSize: '0.9rem',
      },

    },

    h6: {
      fontSize: '0.8rem',
      fontWeight: 600,
      textOverflow: "ellipsis",
      "@media (max-width: 600px)": {
        fontSize: '0.6rem',
      },
      "@media (max-width: 900px)": {
        fontSize: '0.7rem',
      },

    },
    


    body1: {
      fontSize: '18px',
      color: '#878680',
      textOverflow: "ellipsis",
      "@media (max-width: 600px)": {
        fontSize: '12px',
      },
      "@media (max-width: 900px)": {
        fontSize: '16px',
      },
    },
    body2: {
      fontSize: "16px",
      color: "#878680",
      textOverflow: "ellipsis",
      "@media (max-width: 600px)": {
        fontSize: '12px',
      },
      "@media (max-width: 900px)": {
        fontSize: '14px',
      },

    },
    caption: {
      fontSize: "16px",
      color: "#878680",
      textOverflow: "ellipsis",
      "@media (max-width: 600px)": {
        fontSize: '10px',
      },
      "@media (max-width: 900px)": {
        fontSize: '14px',
      },

    }
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#002855', // Consistent header with the primary blue color.
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none', // No uppercase by default for better readability.
          borderRadius: 8, // Slightly rounded corners for a modern look.
        },
        containedPrimary: {
          backgroundColor: 'rgba(24, 116, 210, 1)',
          '&:hover': {
            backgroundColor: 'rgba(24, 116, 210, 1)', // Darker shade for hover state.
          },
        },
        containedSecondary: {
          backgroundColor: '#ff6f00',
          '&:hover': {
            backgroundColor: '#ff8f00', // Slightly lighter orange for hover effect.
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 4px 8px rgba(0,0,0,0.1)', // Soft shadow for cards to make them stand out.
          borderRadius: 8,
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          lineHeight: 1.6, // Line height for better readability.
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: '#ff6f00', // Use orange for links to stand out.
          textDecoration: 'none',
          '&:hover': {
            textDecoration: 'underline',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          padding: '16px',
          backgroundColor: '#ffffff',
        },
      },
    },
  },
});

export default theme;
